import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, css } from 'styled-components';
import { ResourcePreviewContent } from '../../../ResourcePreview/ResourcePreviewGrid/Content/ResourcePreviewContent.js';
import { ResourcePathAndName } from './ResourcePathAndName.js';
import { ResourcePreviewTags } from '../../../ResourcePreview/ResourcePreviewGrid/ResourcePreviewTags.js';
import { ResourceAttributes } from './ResourceAttributes.js';
import { RESOURCE_GRID_PREVIEW_CONTENT } from '@fabric-app/ui/theme/resourcePreviewConstants';
import { preventForwardPropsConfig } from '@fabric-app/ui/utils/preventForwardProps';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { IconSharedWithPublic } from '../../../IconSharedWithPublic.js';
import { ResourcePreviewPinnedComment } from '../../../ResourcePreview/ResourcePreviewGrid/ResourcePreviewComment.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import { getOriginUrlWithHash } from '../../../../utils/getOriginUrlWithHash.js';
import { LinkExternal } from '@fabric-app/ui/components/Link/LinkExternal';
import { FloatingExternalLinkButton } from '../../../ResourcePreview/ResourcePreviewGrid/components/FloatingExternalLinkButton.js';
import { motion } from 'framer-motion';

const ResourceSearchResultItem = (props) => {
  const { children, appearence: appearenceProp, draggableRef, onMouseDown, className, isSelected, isSelectable, onClickResource, resource, zoomLevel, ...rest } = props;
  const externalUrl = resource._meta?.externalData?.url;
  return /* @__PURE__ */ jsxs(Container, {
    as: motion.div,
    whileTap: {
      backgroundColor: `rgba(${cssVar["color-bg-primary-reverse-rgb"]}, 0.04)`
    },
    "data-selectable-id": resource.isDraft || !isSelectable ? void 0 : resource?.id,
    onMouseDown,
    onClick: () => onClickResource?.(resource),
    ref: draggableRef,
    isSelected,
    ...rest,
    children: [
      externalUrl ? /* @__PURE__ */ jsx(StyledFloatingExternalLinkButtonReference, {
        as: LinkExternal,
        href: getOriginUrlWithHash(externalUrl, resource.id),
        "data-preview-resource-external-link": true
      }) : resource.originUrl ? /* @__PURE__ */ jsx(FloatingExternalLinkButton, {
        as: LinkExternal,
        href: getOriginUrlWithHash(resource.originUrl, resource.id),
        "data-preview-resource-external-link": true
      }) : null,
      /* @__PURE__ */ jsx(ThumbnailContainer, {
        zoomLevel: zoomLevel ?? 1,
        children: /* @__PURE__ */ jsx(ThumbnailContainerInner, {
          zoomLevel: zoomLevel ?? 1,
          children: /* @__PURE__ */ jsx(ResourcePreviewContent, {})
        })
      }),
      /* @__PURE__ */ jsxs(ContentContainer, {
        children: [
          /* @__PURE__ */ jsx(ResourcePathAndName, {}),
          /* @__PURE__ */ jsx(ResourceAttributes, {}),
          /* @__PURE__ */ jsx(ResourcePreviewTags, {
            tags: resource.tags
          }),
          resource.isDirectShared || resource.commentPinned ? /* @__PURE__ */ jsxs(Flex, {
            gap: "text",
            style: {
              maxWidth: "300px"
            },
            children: [
              resource.isDirectShared && /* @__PURE__ */ jsx(IconSharedWithPublic, {}),
              resource.commentPinned && /* @__PURE__ */ jsx(ResourcePreviewPinnedComment, {
                comment: resource.commentPinned
              })
            ]
          }) : null
        ]
      })
    ]
  });
};
const StyledFloatingExternalLinkButtonReference = styled(FloatingExternalLinkButton).withConfig({
  displayName: "ResourceSearchResultItem__StyledFloatingExternalLinkButtonReference",
  componentId: "sc-cc7ea542-0"
})([
  `top:-0.5rem;right:-0.5rem;color:`,
  `;background:transparent;border:none;display:flex;`
], cssVar["color-text-primary"]);
const Container = styled.div.withConfig(preventForwardPropsConfig([
  "isSelected"
])).withConfig({
  displayName: "ResourceSearchResultItem__Container",
  componentId: "sc-cc7ea542-1"
})([
  `display:flex;align-items:center;gap:30px;cursor:pointer;padding:0.75rem;border-radius:1rem;position:relative;transition:0.1s background-color;&:after{inset:0;position:absolute;content:'';border-radius:1rem;background:rgba(42,55,238,0.2);border:2px solid rgba(42,55,238,0.4);pointer-events:none;display:none;}&:not(:hover){`,
  `{opacity:0;scale:0.8;}`,
  `{opacity:0.4;scale:1;}}`,
  `{&:hover{background-color:rgba(`,
  `,0.04);}`,
  `}`
], FloatingExternalLinkButton, StyledFloatingExternalLinkButtonReference, mediaHover, cssVar["color-bg-primary-reverse-rgb"], ({ isSelected }) => isSelected && css([
  `&:after{display:block;}`
]));
const ThumbnailContainer = styled.div.withConfig({
  displayName: "ResourceSearchResultItem__ThumbnailContainer",
  componentId: "sc-cc7ea542-2"
})([
  `display:flex;flex-direction:column;flex-shrink:0;justify-content:center;align-items:center;`,
  ``
], ({ zoomLevel }) => css([
  `width:`,
  `px;height:`,
  `px;`
], RESOURCE_GRID_PREVIEW_CONTENT.width / 2 * zoomLevel, RESOURCE_GRID_PREVIEW_CONTENT.height / 2 * zoomLevel));
const ThumbnailContainerInner = styled.div.withConfig({
  displayName: "ResourceSearchResultItem__ThumbnailContainerInner",
  componentId: "sc-cc7ea542-3"
})([
  `width:`,
  `px;height:`,
  `px;scale:`,
  `;`
], RESOURCE_GRID_PREVIEW_CONTENT.width, RESOURCE_GRID_PREVIEW_CONTENT.height, ({ zoomLevel }) => zoomLevel * 0.5);
const ContentContainer = styled.div.withConfig({
  displayName: "ResourceSearchResultItem__ContentContainer",
  componentId: "sc-cc7ea542-4"
})([
  `display:flex;flex-direction:column;align-items:flex-start;gap:0.75rem;flex-grow:1;flex-shrink:1;max-width:100%;overflow:hidden;[data-tag-container-inner]{justify-content:flex-start;}`
]);

export { Container, ContentContainer, ResourceSearchResultItem, ThumbnailContainer };
//# sourceMappingURL=ResourceSearchResultItem.js.map
